const config = {
  BASE_API_URL: process.env.NEXT_PUBLIC_API_BASE_URL || 'https://app.roffice.team/api/',
  TIMEOUT: 300000, // 5 minutes = 60x5x1000 = 300000
};
export default config;

// Feature flag for the Harvest time-tracking integration. All Harvest UI is
// hidden unless this is explicitly 'true', matching the backend's
// HARVEST_ENABLED gate so the surface can be dark-shipped and enabled per env.
export const HARVEST_ENABLED = process.env.NEXT_PUBLIC_HARVEST_ENABLED === 'true';

// Current ToS version shipped by this build. Bumped in lockstep with new
// content in `termAndConditions.tsx` (tosVersions map) and a backend
// migration that inserts a matching row in `tos_versions`.
export const CURRENT_TOS_VERSION = '2026-05-11';
